<div class="flex justify-content-between align-items-center">
    <app-switch-input id="active" [form]="form" label="database.persons.contacts.inactive"></app-switch-input>

    @if (isAllowed['folderContact.create']() && !store.isTerminated()) {
        <app-button label="database.persons.contacts.add" icon="pi-user-plus"
            (clickEvent)="addContactDialog()"></app-button>
    }
</div>

@let contacts = store.data.getPersonContacts();
@if (!contacts) {
    <app-loading></app-loading>
} @else if (contacts && contacts['items'] && contacts['items'].length) {
    <div class="gap-large content">
        @for (contact of contacts['items']; track $index) {
            <app-contact-card
                (dragStart)="dragStart($event)"
                (dragEnd)="drop($event)"
                [folderId]="store.folderId()"
                [contact]="contact"
            ></app-contact-card>
        }
    </div>
} @else {
    <app-empty-state></app-empty-state>
}
